import { render, staticRenderFns } from "./PaymentsRightCol.vue?vue&type=template&id=6fa9e5a5&"
import script from "./PaymentsRightCol.vue?vue&type=script&lang=ts&"
export * from "./PaymentsRightCol.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports